export {
  SEMRESATTRS_DEPLOYMENT_ENVIRONMENT,
  SEMRESATTRS_SERVICE_NAME,
  SEMRESATTRS_SERVICE_VERSION,
} from '@opentelemetry/semantic-conventions';

export const ATTRS_SPLIT_ID = 'split.id';
export const ATTRS_USER_ID = 'user.id';

export const ATTRS_ANALYTICS_EVENT_NAME = 'analytics.event.name';
export const ATTRS_ANALYTICS_FUNNEL_NAME = 'analytics.funnel.name';
export const ATTRS_ANALYTICS_FUNNEL_LOCALE = 'analytics.funnel.locale';
export const ATTRS_ANALYTICS_FUNNEL_SCREEN = 'analytics.funnel.screen';

export const ATTRS_WEB_VITALS_NAME = 'webvitals.name';
export const ATTRS_WEB_VITALS_VALUE = 'webvitals.value';
export const ATTRS_WEB_VITALS_PATHNAME = 'webvitals.pathname';

export const ATTRS_TYPE = 'type';
export const ATTRS_ERROR_MESSAGE = 'error.message';
